/* eslint-disable react/no-did-update-set-state */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import Checkbox from 'material-ui/Checkbox';
import IntermediateCheckboxIcon from 'material-ui/svg-icons/toggle/indeterminate-check-box';

export default class IntermediateCheckbox extends Component {
  render() {
    const {intermediate, ...other} = this.props;
    return (
      <Checkbox
        checkedIcon = {intermediate ? <IntermediateCheckboxIcon/> : undefined}
        {...other}
      />
    );
  }
}

IntermediateCheckbox.propTypes = {
  intermediate: PropTypes.bool,
};